import React, {useMemo} from 'react'
import ContainerLayout from '../../../../components/layout/ContainerLayout'
import {ICopierDetail} from '../../../../apis/copier/copierDetail'
import Text from '../../../../components/text/Text'
import {useDisplayNumber} from '../../../../utils/number'
import {useTime} from '../../../../utils/time'
import {useColor} from '../../../../utils/etc'

interface IProps {
    className?: string
    data?: ICopierDetail
}

const GRID = 'grid grid-cols-6 gap-x-[10px] lg:grid-cols-5 md:grid-cols-3'

// admin/copy/copier/:id 의 invoices[]는 아래 필드만 온다.
// leader_name / due_at / high water mark는 이 응답에 없어 컬럼에서 뺐다.
const CopierInvoiceContainer: React.FC<IProps> = ({className, data}) => {
    const {floorBalance} = useDisplayNumber()
    const {localTimeString} = useTime()
    const {getNumberColor} = useColor()

    const invoiceList = useMemo(() => {
        return [...(data?.invoices ?? [])].sort((a, b) => (b?.created_at ?? 0) - (a?.created_at ?? 0))
    }, [data?.invoices])

    return (
        <ContainerLayout title={'Invoices'} className={`${className}`}>
            <Text className={'text-body3 text-font03'}>(Sort by newest)</Text>
            <div className={`${GRID} mt-[5px]`}>
                <Text className={'text-ti3 text-font02'}>Status</Text>
                <Text className={'text-ti3 text-font02'}>Period</Text>
                <Text className={'text-ti3 text-font02 text-center'}>Due Amount</Text>
                <Text className={'text-ti3 text-font02 text-center md:hidden'}>PNL</Text>
                <Text className={'text-ti3 text-font02 text-center lg:hidden'}>Fee Percent</Text>
                <Text className={'text-ti3 text-font02 text-right md:hidden'}>Created At</Text>
            </div>
            <div className={'mt-[10px]'}>
                {invoiceList?.map(invoice => (
                    <div
                        key={invoice?.id}
                        className={`${GRID} items-center py-[15px] border-b border-line03 last:border-0`}>
                        <div>
                            <Text
                                className={`text-ti1 ${invoice?.status === 'paid' ? 'text-primary' : 'text-font_red'}`}>
                                {invoice?.status?.toUpperCase()}
                            </Text>
                        </div>
                        <div>
                            <Text className={'text-body3 text-font03'}>
                                {invoice?.from_time ? localTimeString(invoice?.from_time) : '-'}
                            </Text>
                            <Text className={'text-body3 text-font03'}>
                                ~ {invoice?.to_time ? localTimeString(invoice?.to_time) : '-'}
                            </Text>
                        </div>
                        <div>
                            <Text
                                className={`text-center ${
                                    invoice?.amount - invoice?.paid !== 0 && 'text-ti2 text-font_red'
                                }`}>
                                ${floorBalance(invoice?.amount - invoice?.paid, 100, false)} (Total. $
                                {floorBalance(invoice?.amount, 100, false)})
                            </Text>
                        </div>
                        <div className={'md:hidden text-center'}>
                            <Text className={`text-ti2 ${getNumberColor(invoice?.pnl)}`}>
                                ${floorBalance(invoice?.pnl, 100, false)}
                            </Text>
                        </div>
                        <div className={'lg:hidden text-center'}>
                            <Text className={'text-ti2 text-font02'}>{invoice?.cut_percent}%</Text>
                        </div>
                        <div className={'text-right md:hidden'}>
                            <Text className={'text-body3 text-font03'}>
                                {invoice?.created_at ? localTimeString(invoice?.created_at) : '-'}
                            </Text>
                        </div>
                    </div>
                ))}
                {!invoiceList?.length && (
                    <div className={'py-[15px] text-center'}>
                        <Text>No Items</Text>
                    </div>
                )}
            </div>
        </ContainerLayout>
    )
}

export default CopierInvoiceContainer
